<template>
    <div>
      <h6
        style="font-weight: 400; margin: 0px !important; padding: 0px !important"
      >
        {{ currencyFormatter(VALUE, params.data.doviz == "USD"
                          ? "$"
                          : item.doviz == "EUR"
                          ? "€"
                          : "₺") }}
      </h6>
    </div>
  </template>
      <script>
      import moment from "moment";
  export default {
    data() {
      return {
        VALUE: "",
      };
    },
    created() {
      this.VALUE = this.params.value;
    },
    methods:{
        currencyFormatter(currency, sign) {
      if (currency == "") {
        return "";
      } else {
        var sansDec = currency.toFixed(2);
        var formatted = sansDec.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        return `${formatted}` + sign;
      }
    },
    }
  };
  </script>
      